import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import DeliveryChallansGeneral from './components/deliveryChallansGeneral';
import DeliveryChallansFieldCustomisation from './components/deliveryChallansFieldCustomisation';
import { toast } from 'react-toastify';
import {
	getDeliveryChallanGeneral,
	UpdateDeliveryChallanGeneral,
} from '../../../../../services/settings/sales';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

export default function DeliveryChallans({ activeTab }) {
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [loader, setLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [generalForm, setGeneralForm] = useState({});
	const [form, setForm] = useState({
		terms_and_conditions: '',
		customer_notes: '',
	});

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(generalForm) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};

	const handleDelivaryChallan = async () => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			setIsEdit(false);
			const res = await UpdateDeliveryChallanGeneral(form);
			if (res.success) {
				toast.success(res.message);
				getDeliveryChallan();
			} else {
				setIsEdit(true);
				toast.error(res.message);
			}
		} catch (error) {
			setIsEdit(true);
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};

	const getDeliveryChallan = async () => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));

			const { delivery_challan_settings } = await getDeliveryChallanGeneral();
			var data = {
				terms_and_conditions:
					delivery_challan_settings.terms_and_conditions !== null &&
						delivery_challan_settings.terms_and_conditions !== 'null'
						? delivery_challan_settings.terms_and_conditions
						: '',
				customer_notes:
					delivery_challan_settings.customer_notes !== null &&
						delivery_challan_settings.customer_notes !== 'null'
						? delivery_challan_settings.customer_notes
						: '',
			};
			setForm(data);
			setGeneralForm(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};
	const handleCustomField = () => { };

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	useEffect(() => {
		getDeliveryChallan();
	}, []);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={tab === 'Field Customisation' ? [
					{
						id: 1,
						button: 'Add New Custom Field',
						add: true,
						close: false,
						disabled: false,
						handler: () => {
							setIsCreateForm(true)
						},
						className: 'btn-primary',
					},
				] : [
					{
						id: 1,
						disabled: !isEdit || loader.isLoader && loader.isSave,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: loader.isLoader && loader.isSave,
						handler: () => {
							handleDelivaryChallan();
						},
					},
					isEdit && {
						id: 2,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changed',
						handler: () => {
							setIsEdit(false);
							getDeliveryChallan();
						},
					}
				].filter((button) => button !== false)}
			/>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 0, zIndex: 100 }}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<DeliveryChallansGeneral
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					loader={loader}
				/>
			) : (
				<DeliveryChallansFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
